if (!customElements.get('ri-unified-card')) {
  customElements.define('ri-unified-card', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (this.ready || !this.isConnected) return;
      this.ready = true;
      this.select = this.querySelector('select[name="id"]');
      this.button = this.querySelector('button[type="submit"]');
      this.select?.addEventListener('change', () => this.updateVariant());
      this.updateVariant();
    }

    updateVariant() {
      const option = this.select?.selectedOptions[0];
      if (!option) return;
      this.querySelector('.ri-meal-price').textContent = option.dataset.price;
      const unit = this.querySelector('.ri-meal-unit');
      if (unit) unit.textContent = option.dataset.unit;
      this.querySelectorAll('.ri-meal-photo,.ri-meal-title').forEach(link => { link.href = option.dataset.url; });
      const available = option.dataset.available === 'true';
      const label = available ? this.dataset.addLabel : this.dataset.soldLabel;
      this.button.disabled = !available;
      if (!this.button.classList.contains('loading')) this.button.removeAttribute('aria-disabled');
      this.button.querySelector('[data-ri-button-label]').textContent = label;
      this.button.setAttribute('aria-label', `${label} — ${this.dataset.productTitle}`);
      this.querySelector('.product-form__error-message-wrapper').hidden = true;
    }
  });
}
